import { Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoMark } from "../Logo";
import { scrollToSection } from "../../lib/api";

export function Footer({ settings, hasEvents }) {
  const links = [
    ["Home", "#top"],
    ["Menu", "#menu"],
    ["Prenota", "#prenota"],
    ["Galleria", "#galleria"],
    ...(hasEvents ? [["Eventi", "#eventi"]] : []),
    ["Contatti", "#contatti"],
  ];

  return (
    <footer className="bg-obsidian border-t border-white/10 pt-16 pb-28 md:pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-4">
              <LogoMark className="h-9" />
              <div>
                <p className="text-[9px] font-semibold uppercase tracking-[0.4em] text-gold-glow/80">Ceccano (FR)</p>
              </div>
            </div>
            <p className="mt-4 text-sm text-cream-subtle">Bar • Ristopub • Pizzeria</p>
            <p className="text-sm text-cream-subtle">{settings?.address} — {settings?.city}</p>
            {(settings?.instagram || settings?.facebook) && (
              <div className="mt-5 flex gap-3">
                {settings.instagram && (
                  <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="p-2.5 rounded-full border border-white/10 text-cream-muted hover:text-gold-glow hover:border-gold/40 transition-colors">
                    <Instagram className="w-4 h-4" />
                  </a>
                )}
                {settings.facebook && (
                  <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="p-2.5 rounded-full border border-white/10 text-cream-muted hover:text-gold-glow hover:border-gold/40 transition-colors">
                    <Facebook className="w-4 h-4" />
                  </a>
                )}
              </div>
            )}
          </div>

          <nav className="grid grid-cols-2 gap-x-14 gap-y-3">
            {links.map(([label, hash]) => (
              <button
                key={label}
                onClick={() => scrollToSection(hash === "#top" ? "body" : hash)}
                className="text-left text-xs uppercase tracking-[0.22em] text-cream-muted hover:text-gold-glow transition-colors"
              >
                {label}
              </button>
            ))}
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs uppercase tracking-[0.22em] text-cream-muted hover:text-gold-glow transition-colors">
              Privacy Policy
            </Link>
            <Link to="/cookie-policy" data-testid="footer-cookie-link" className="text-xs uppercase tracking-[0.22em] text-cream-muted hover:text-gold-glow transition-colors">
              Cookie Policy
            </Link>
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2 text-[11px] text-cream-subtle/70">
          <p>© {new Date().getFullYear()} Red Stone — Ceccano (FR). Tutti i diritti riservati.</p>
          <p>Pizza, gusto e serate da vivere.</p>
        </div>
      </div>
    </footer>
  );
}
